import { render, staticRenderFns } from "./SetHandleEdit.vue?vue&type=template&id=1494dbbe&scoped=true"
import script from "./SetHandleEdit.vue?vue&type=script&lang=js"
export * from "./SetHandleEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1494dbbe",
  null
  
)

export default component.exports